import React from 'react';
import { formatCurrency } from 'utils';
import { Typography } from '@mui/material';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing/types';
import { Charge } from '../../../types';

interface Props {
  form: UseFormReturn<ListingForm<Charge>>;
  field: keyof Charge;
}

export const ChargeTotalCell = ({ form, field }: Props) => {
  const bodyFields = useWatch({ control: form.control, name: 'bodyFields' });

  const total = (bodyFields ?? []).reduce<number>((total, row) => {
    if (typeof row[field] === 'number') {
      total += +row[field];
    }

    return total;
  }, 0);

  return <Typography>{formatCurrency(total, true)}</Typography>;
};
